/**
 * GET /objects/:objectListId/fields/:fieldId/linked — постраничный список связанных объектов.
 * status_date — срез версии (пусто = текущие значения).
 */
export function buildObjectPassportLinkedListUrl(
  objectListId: number,
  fieldId: number,
  page: number,
  perPage: number,
  statusDate?: string | null,
): string {
  const params = new URLSearchParams({
    page: String(Math.max(1, page)),
    per_page: String(Math.max(1, perPage)),
  })
  if (statusDate) params.set('status_date', statusDate)
  return `/objects/${objectListId}/fields/${fieldId}/linked?${params.toString()}`
}

/**
 * Bulk-имена и координаты дочерних объектов для обогащения строк linked-таблицы.
 */
export function buildPassportBulkObjectsUrl(objectIds: number[]): string {
  const ids = objectIds.filter((id) => Number.isFinite(id) && id > 0)
  if (!ids.length) return ''
  const params = new URLSearchParams({ object_ids: ids.join(',') })
  return `/inventory/objects/passport?${params.toString()}`
}
